module.exports = __webpack_public_path__ + "static/media/FrutigerNeueLTW04-Black.35fd3f3d.eot";